import { render } from "./CookiesRadioButton.vue?vue&type=template&id=120c4003&scoped=true"
import script from "./CookiesRadioButton.vue?vue&type=script&lang=js"
export * from "./CookiesRadioButton.vue?vue&type=script&lang=js"

import "./CookiesRadioButton.vue?vue&type=style&index=0&id=120c4003&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120c4003"]])

export default __exports__